import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgentType, HGSAgentType } from "src/app/constants/agent";
import { MaskType } from "src/app/constants/masks";
import { USStates } from "src/app/constants/us-states";
import { AgentUser } from "src/app/models/agent";
import { AgentService } from "src/app/services/agent.service";

import { FormValidationService } from "src/app/services/form-validation.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-agent-form',
    templateUrl: './agent-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentFormComponent implements OnInit {
    @Input() public agent: AgentUser;
    @Input() public hasAccessToAllBrokers: boolean;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<any> = new EventEmitter();

    public maskType = MaskType;
    public usStates = USStates;
    public agentType = AgentType;
    public hgsAgentType = HGSAgentType;
    public agentForm: FormGroup;
    public isNewAgent: boolean;
    public formTitle: string;
    public saveButtonText: string;
    public displayForm: boolean;
    private reloadForm: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
        private agentService: AgentService,
    ) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.displayForm = false;

        this.isNewAgent = this.agent.id === 0;
        this.formTitle = this.isNewAgent ? "New Agent" : "Edit Agent";
        this.saveButtonText = this.isNewAgent ? "Create Agent" : "Save";

        this.agentForm = this.formBuilder.group({
            firstName: [this.agent.firstName, Validators.required],
            middleName: [this.agent.middleName],
            lastName: [this.agent.lastName, Validators.required],
            uid: [{ value: this.agent.uid, disabled: true }],
            email: [this.agent.email, [Validators.required, Validators.compose([FormValidationService.validEmail(true)])]],
            address: [this.agent.address],
            city: [this.agent.city],
            state: [this.agent.state],
            zipCode: [this.agent.zipCode, FormValidationService.validZipcode()],
            phone: [this.agent.phone, FormValidationService.validPhoneNumber()],
            fax: [this.agent.fax, FormValidationService.validPhoneNumber()],
            type: [this.agent.type, Validators.required],
            resetPassword: [false]
        });

        this.displayForm = true;
    }

    public back(): void {
        if (this.reloadForm)
            this.emitSave.emit();
        else
            this.emitCancel.emit();
    }

    public resetPassword(): void {
        this.agentService.resetAgentPassword(this.agent).subscribe((response: AgentUser) => {
        });
    }

    public saveAgent(): void {
        const l_AgentPayload = this.helperService.convertFormGroupIntoObject(this.agentForm, new AgentUser());

        if (this.isNewAgent) {
            this.agentService.createAgent(l_AgentPayload).subscribe((response: AgentUser) => {
                this.reloadForm = true;
                this.agent = response;
                this.buildForm();
            });
        } else {
            l_AgentPayload.id = this.agent.id;
            this.agentService.editAgent(l_AgentPayload).subscribe((response: AgentUser) => {
                this.reloadForm = true;
            });
        }
    }
}